// app/core/guards/auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';
import { map, catchError, of } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const session = inject(SessionService);
  const userService = inject(UserService);
  const router = inject(Router);

  const token = session.currentToken;

  if (!token) {
    // Pas de token → redirection vers /signin
    return router.createUrlTree(['/signin']);
  }

  // Si le user est déjà en mémoire → accès direct
  if (userService.currentUser) {
    return true;
  }

  // Sinon → on charge le profil avant d’autoriser
  return userService.loadProfile().pipe(
    map(() => true), // succès → accès autorisé
    catchError(() => of(router.createUrlTree(['/signin']))) // erreur → redirection
  );
};
